import {
  CHANGE_TAB,
  UPDATE_UI_PROPERTY,
  CHANGE_SIZE,
  FULLY_LOADED,
  CHANGE_VIEW,
  TOGGLE_PORT,
  TOGGLE_SHIPYARD
} from "../action/ui.action";

const initialState = {
  mapRefresher: 0,
  currentTab: "FLEET-PRODUCTS",
  currentSize: 1500,
  baseLayer:'mapbox://styles/mapbox/streets-v11',
  precipitation:false,
  fullyLoad: false,
  currentView:"mapView",
  showPort:false,
  showShipyard: false
};

export default function uiReducer(state = initialState, action) {
  switch (action.type) {
    case CHANGE_TAB:
      let currentTab = action.payload
      Object.assign(state, currentTab)
      return {
        ...state,
        ui:{
          mapRefresher: state.mapRefresher +1,
          currentSize: state.currentSize,
          baseLayer:state.baseLayer,
          precipitation:state.precipitation,
          currentTab: currentTab,
          fullyLoad: false
        },
      }

    case CHANGE_VIEW:
      let currentView = action.payload
      return {
        ...state,
        currentView: currentView,
      }
    case TOGGLE_PORT:
      return {
        ...state,
        showPort: !state.showPort,
      }
    case TOGGLE_SHIPYARD:
      return {
        ...state,
        showShipyard: !state.showShipyard,
      }
    case FULLY_LOADED:
      Object.assign(state, {fullyLoad: true})
      return {
        ...state,
        ui:{
          mapRefresher: state.mapRefresher +1,
          currentSize: state.currentSize,
          baseLayer:state.baseLayer,
          precipitation:state.precipitation,
          currentTab: state.currentTab,
          fullyLoad: true
        },
      }
    case UPDATE_UI_PROPERTY:
      Object.assign(state, action.payload)
      return{
        ...state,
      }
    case CHANGE_SIZE:
      let currentSize = action.payload
      return{
        ...state,
        ...currentSize,
        mapRefresher: (state.mapRefresher+1)
      }
    default:
      return state;
  }
}